<router-outlet></router-outlet>

<val-default-errors>
  <ng-template valError="required" let-label>{{ label || 'Это поле' }} обязательно для заполнения</ng-template>
  <ng-template valError="email" let-label>{{ label || 'Поле' }} должно быть действующим email</ng-template>
  <ng-template valError="minlength" let-error="error" let-label
    >{{ label || 'Это поле' }} должно содержать не менее {{ error.requiredLength }} символов</ng-template
  >
  <ng-template valError="maxlength" let-error="error" let-label
    >{{ label || 'Это поле' }} должно содержать не более {{ error.requiredLength }} символов</ng-template
  >
  <ng-template valError="pattern" let-error="error" let-label>{{ label || 'Поле' }} должно содержать корректный номер телефона</ng-template>
  <ng-template valError="pattern" let-error="error" let-label
    >{{ label || 'Это поле' }} должно содержать только цифры{{ error.number }}</ng-template
  >
  <ng-template valError="equalTo" let-error="error" let-label>{{ label || 'Пароль' }} должен совпадать</ng-template>
  <ng-template valError="invalidPhoneNumber" let-label>{{ label || 'Номер должен быть в формате +375XX' }}</ng-template>
  <ng-template valError="underage" let-label>{{ label || 'Регистрация доступна только для пользователей, достигших 18 лет' }}</ng-template>
  <ng-template valError="twoDecimals" let-label> {{ label || 'Значение' }} должно содержать не более 2 знаков после запятой </ng-template>
</val-default-errors>
